import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const targetActionTypes = {
  LOAD: type('[Target] Load'),
  LOAD_SUCCESS: type('[Target] Load Success'),
  LOAD_FAIL: type('[Target] Load Fail'),
};

export class LoadTargetAction implements Action {
  readonly type = targetActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadTargetSuccessAction implements Action {
  readonly type = targetActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadTargetFailAction implements Action {
  readonly type = targetActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}


